(function (_, Kotlin, $module$klock_root_klock_jsLegacy, $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy, $module$kotlinx_serialization_kotlinx_serialization_json_jsLegacy) {
  'use strict';
  var Kind_CLASS = Kotlin.Kind.CLASS;
  var L0 = Kotlin.Long.ZERO;
  var equals = Kotlin.equals;
  var listOf = Kotlin.kotlin.collections.listOf_i5x0yv$;
  var Kind_OBJECT = Kotlin.Kind.OBJECT;
  var DateFormat = $module$klock_root_klock_jsLegacy.com.soywiz.klock.DateFormat;
  var parseDate = $module$klock_root_klock_jsLegacy.com.soywiz.klock.parseDate_mabgv2$;
  var ArrayList_init = Kotlin.kotlin.collections.ArrayList_init_287e2$;
  var numberToDouble = Kotlin.numberToDouble;
  var kotlin_js_internal_LongCompanionObject = Kotlin.kotlin.js.internal.LongCompanionObject;
  var serializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.builtins.serializer_vbrujs$;
  var kotlin_js_internal_StringCompanionObject = Kotlin.kotlin.js.internal.StringCompanionObject;
  var serializer_0 = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.builtins.serializer_6eet4j$;
  var ListSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.builtins.ListSerializer_swdriu$;
  var Unit = Kotlin.kotlin.Unit;
  var Json = $module$kotlinx_serialization_kotlinx_serialization_json_jsLegacy.kotlinx.serialization.json.Json_x26noe$;
  var mutableListOf = Kotlin.kotlin.collections.mutableListOf_i5x0yv$;
  var NullableSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.NullableSerializer;
  var PluginGeneratedSerialDescriptor = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.PluginGeneratedSerialDescriptor;
  var internal = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal;
  var LinkedHashMapSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.LinkedHashMapSerializer;
  var UnknownFieldException = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.UnknownFieldException;
  var GeneratedSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.GeneratedSerializer;
  var ArrayListSerializer = $module$kotlinx_serialization_kotlinx_serialization_core_jsLegacy.kotlinx.serialization.internal.ArrayListSerializer;
  var ensureNotNull = Kotlin.ensureNotNull;
  var indexOf = Kotlin.kotlin.text.indexOf_l5u8uk$;
  var LinkedHashMap_init = Kotlin.kotlin.collections.LinkedHashMap_init_q3lmfv$;
  var endsWith = Kotlin.kotlin.text.endsWith_7epoxm$;
  BooleanSchema.prototype = Object.create(ValueSchema.prototype);
  BooleanSchema.prototype.constructor = BooleanSchema;
  MaybeSchema.prototype = Object.create(ValueSchema.prototype);
  MaybeSchema.prototype.constructor = MaybeSchema;
  DateStringSchema.prototype = Object.create(MaybeSchema.prototype);
  DateStringSchema.prototype.constructor = DateStringSchema;
  ListSchema.prototype = Object.create(ValueSchema.prototype);
  ListSchema.prototype.constructor = ListSchema;
  MapSchema.prototype = Object.create(ValueSchema.prototype);
  MapSchema.prototype.constructor = MapSchema;
  NumberSchema.prototype = Object.create(MaybeSchema.prototype);
  NumberSchema.prototype.constructor = NumberSchema;
  PairSchema.prototype = Object.create(ValueSchema.prototype);
  PairSchema.prototype.constructor = PairSchema;
  RecordSchema.prototype = Object.create(MaybeSchema.prototype);
  RecordSchema.prototype.constructor = RecordSchema;
  StringSchema.prototype = Object.create(ValueSchema.prototype);
  StringSchema.prototype.constructor = StringSchema;
  function DummyType(dummyType) {
    if (dummyType === void 0)
      dummyType = null;
    this.dummyType = dummyType;
  }
  DummyType.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DummyType',
    interfaces: []
  };
  DummyType.prototype.component1 = function () {
    return this.dummyType;
  };
  DummyType.prototype.copy_gdg4nx$ = function (dummyType) {
    return new DummyType(dummyType === void 0 ? this.dummyType : dummyType);
  };
  DummyType.prototype.toString = function () {
    return 'DummyType(dummyType=' + Kotlin.toString(this.dummyType) + ')';
  };
  DummyType.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.dummyType) | 0;
    return result;
  };
  DummyType.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.dummyType, other.dummyType))));
  };
  function isNullOrZero($receiver) {
    return $receiver == null || $receiver === 0;
  }
  function isNullOrZero_0($receiver) {
    return $receiver == null || equals($receiver, L0);
  }
  function isNullOrZero_1($receiver) {
    return $receiver == null || Kotlin.compareTo($receiver, 0) === 0;
  }
  function BooleanSchema(name, initialValue) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    ValueSchema.call(this, name, initialValue);
  }
  BooleanSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'BooleanSchema',
    interfaces: [ValueSchema]
  };
  function DateStringSchema(name, initialValue, isRequired, dateFormat, minDate, maxDate) {
    DateStringSchema$Companion_getInstance();
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    if (isRequired === void 0)
      isRequired = false;
    if (dateFormat === void 0)
      dateFormat = DateStringSchema$Companion_getInstance().DEFAULT_DATE_FORMAT;
    if (minDate === void 0)
      minDate = null;
    if (maxDate === void 0)
      maxDate = null;
    MaybeSchema.call(this, name, initialValue, isRequired);
    this.dateFormat = dateFormat;
    this.minDate = minDate;
    this.maxDate = maxDate;
  }
  function DateStringSchema$Companion() {
    DateStringSchema$Companion_instance = this;
    this.DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
    this.SUPPORTED_DATE_FORMATS = listOf(['yyyy-MM-dd', 'yyyy/MM/dd', 'yyyyMMdd']);
  }
  DateStringSchema$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var DateStringSchema$Companion_instance = null;
  function DateStringSchema$Companion_getInstance() {
    if (DateStringSchema$Companion_instance === null) {
      new DateStringSchema$Companion();
    }return DateStringSchema$Companion_instance;
  }
  DateStringSchema.prototype.isValid_11rb$$default = function (value) {
    return this.isValid_11rb$(value, MaybeSchema.prototype.isValid_11rb$$default.bind(this)) && this.formatIsSupported_0() && this.minDateIsValid_pdl1vj$(value) && this.maxDateIsValid_pdl1vj$(value);
  };
  DateStringSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = this.validate_l9l8mx$(value, path, MaybeSchema.prototype.validate_l9l8mx$$default.bind(this));
    if (!this.minDateIsValid_pdl1vj$(value) || !this.maxDateIsValid_pdl1vj$(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_DATE_OUT_OF_BOUNDS, void 0, void 0, path));
    }if (!this.formatIsSupported_0()) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_DATE_UNSUPPORTED_FORMAT, void 0, void 0, path));
    }return validator;
  };
  DateStringSchema.prototype.minDateIsValid_pdl1vj$ = function (value) {
    if (value == null || this.minDate == null) {
      return true;
    }var format = DateFormat.Companion.invoke_61zpoe$(DateStringSchema$Companion_getInstance().DEFAULT_DATE_FORMAT);
    var date = parseDate(format, value);
    var minDate = parseDate(format, this.minDate);
    return date.compareTo_11rb$(minDate) >= 0;
  };
  DateStringSchema.prototype.maxDateIsValid_pdl1vj$ = function (value) {
    if (value == null || this.maxDate == null) {
      return true;
    }var format = DateFormat.Companion.invoke_61zpoe$(DateStringSchema$Companion_getInstance().DEFAULT_DATE_FORMAT);
    var date = parseDate(format, value);
    var maxDate = parseDate(format, this.maxDate);
    return date.compareTo_11rb$(maxDate) <= 0;
  };
  DateStringSchema.prototype.formatIsSupported_0 = function () {
    return DateStringSchema$Companion_getInstance().SUPPORTED_DATE_FORMATS.contains_11rb$(this.dateFormat);
  };
  DateStringSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'DateStringSchema',
    interfaces: [MaybeSchema]
  };
  function ListSchema(name, initialValue, childRecordSchema, minSize, maxSize) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0) {
      initialValue = ArrayList_init();
    }if (minSize === void 0)
      minSize = null;
    if (maxSize === void 0)
      maxSize = null;
    ValueSchema.call(this, name, initialValue);
    this.childRecordSchema = childRecordSchema;
    this.minSize = minSize;
    this.maxSize = maxSize;
  }
  ListSchema.prototype.isValid_11rb$$default = function (value) {
    return this.minSizeIsValid_0(value) && this.maxSizeIsValid_0(value) && this.entriesHasValidSchema_0(value);
  };
  ListSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = new ValidationErrors();
    if (!this.minSizeIsValid_0(value) || !this.maxSizeIsValid_0(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_SIZE_OUT_OF_BOUNDS, void 0, void 0, path));
    }if (value != null) {
      var i = 0;
      for (var tmp$ = value.iterator(); tmp$.hasNext(); ++i) {
        var el = tmp$.next();
        validator.addErrors_ngmtp$(this.childRecordSchema.validate_l9l8mx$(el, appendToPath(path, i.toString())));
      }
    }return validator;
  };
  ListSchema.prototype.minSizeIsValid_0 = function (value) {
    if (this.minSize == null) {
      return true;
    }return value == null || value.size >= this.minSize;
  };
  ListSchema.prototype.maxSizeIsValid_0 = function (value) {
    if (this.maxSize == null) {
      return true;
    }return value == null || value.size <= this.maxSize;
  };
  ListSchema.prototype.entriesHasValidSchema_0 = function (value) {
    if (value == null) {
      return true;
    }var tmp$;
    tmp$ = value.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      if (!this.childRecordSchema.isValid_11rb$(element)) {
        return false;
      }}
    return true;
  };
  ListSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ListSchema',
    interfaces: [ValueSchema]
  };
  function MapSchema(name, initialValue, childRecordSchema, minSize, maxSize) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    if (minSize === void 0)
      minSize = null;
    if (maxSize === void 0)
      maxSize = null;
    ValueSchema.call(this, name, initialValue);
    this.childRecordSchema = childRecordSchema;
    this.minSize = minSize;
    this.maxSize = maxSize;
  }
  MapSchema.prototype.isValid_11rb$$default = function (value) {
    return this.minSizeIsValid_0(value) && this.maxSizeIsValid_0(value) && this.entriesHasValidSchema_0(value);
  };
  MapSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var tmp$;
    var validator = new ValidationErrors();
    if (value == null) {
      return validator;
    }if (!this.minSizeIsValid_0(value) || !this.maxSizeIsValid_0(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_SIZE_OUT_OF_BOUNDS, void 0, void 0, path));
    }tmp$ = value.entries.iterator();
    while (tmp$.hasNext()) {
      var tmp$_0 = tmp$.next();
      var k = tmp$_0.key;
      var v = tmp$_0.value;
      validator.addErrors_ngmtp$(this.childRecordSchema.validate_l9l8mx$(v, appendToPath(path, k.toString())));
    }
    return validator;
  };
  MapSchema.prototype.minSizeIsValid_0 = function (value) {
    if (this.minSize == null) {
      return true;
    }return value != null && value.size >= this.minSize;
  };
  MapSchema.prototype.maxSizeIsValid_0 = function (value) {
    if (this.maxSize == null) {
      return true;
    }return value == null || value.size <= this.maxSize;
  };
  MapSchema.prototype.entriesHasValidSchema_0 = function (value) {
    if (value == null) {
      return true;
    }var tmp$;
    tmp$ = value.entries.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var entry = element.value;
      if (!this.childRecordSchema.isValid_11rb$(entry)) {
        return false;
      }}
    return true;
  };
  MapSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MapSchema',
    interfaces: [ValueSchema]
  };
  function MaybeSchema(name, initialValue, isRequired) {
    if (name === void 0)
      name = '';
    if (isRequired === void 0)
      isRequired = false;
    ValueSchema.call(this, name, initialValue);
    this.isRequired = isRequired;
  }
  MaybeSchema.prototype.isValid_11rb$$default = function (value) {
    return this.requiredIsValid_11rb$(value);
  };
  MaybeSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = new ValidationErrors();
    if (!this.requiredIsValid_11rb$(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_IS_REQUIRED, void 0, void 0, path));
    }return validator;
  };
  MaybeSchema.prototype.requiredIsValid_11rb$ = function (value) {
    if (this.isRequired && value === null) {
      return false;
    }return true;
  };
  MaybeSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'MaybeSchema',
    interfaces: [ValueSchema]
  };
  function NumberSchema(name, initialValue, isRequired, min, max) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    if (isRequired === void 0)
      isRequired = false;
    if (min === void 0)
      min = null;
    if (max === void 0)
      max = null;
    MaybeSchema.call(this, name, initialValue, isRequired);
    this.min = min;
    this.max = max;
  }
  NumberSchema.prototype.isValid_11rb$$default = function (value) {
    return this.isValid_11rb$(value, MaybeSchema.prototype.isValid_11rb$$default.bind(this)) && this.minIsValid_rcaewn$(value) && this.maxIsValid_rcaewn$(value);
  };
  NumberSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = this.validate_l9l8mx$(value, path, MaybeSchema.prototype.validate_l9l8mx$$default.bind(this));
    if (!this.minIsValid_rcaewn$(value) || !this.maxIsValid_rcaewn$(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_NUMBER_OUT_OF_BOUNDS, void 0, void 0, path));
    }return validator;
  };
  NumberSchema.prototype.minIsValid_rcaewn$ = function (value) {
    if (this.min !== null && value != null && numberToDouble(value) < this.min) {
      return false;
    }return true;
  };
  NumberSchema.prototype.maxIsValid_rcaewn$ = function (value) {
    if (this.max !== null && value != null && numberToDouble(value) > this.max) {
      return false;
    }return true;
  };
  NumberSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'NumberSchema',
    interfaces: [MaybeSchema]
  };
  function PairSchema(name, initialValue, child1RecordSchema, child2RecordSchema) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    ValueSchema.call(this, name, initialValue);
    this.child1RecordSchema = child1RecordSchema;
    this.child2RecordSchema = child2RecordSchema;
  }
  PairSchema.prototype.isValid_11rb$$default = function (value) {
    if (value === null || value.size !== 2) {
      return true;
    }return this.child1RecordSchema.isValid_11rb$(value.get_za3lpa$(0)) && this.child2RecordSchema.isValid_11rb$(value.get_za3lpa$(1));
  };
  PairSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'PairSchema',
    interfaces: [ValueSchema]
  };
  function RecordSchema(name, initialValue, isRequired) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    if (isRequired === void 0)
      isRequired = false;
    MaybeSchema.call(this, name, initialValue, isRequired);
  }
  RecordSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'RecordSchema',
    interfaces: [MaybeSchema]
  };
  function StringSchema(name, initialValue, minLength, maxLength, isRequired) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = '';
    if (minLength === void 0)
      minLength = null;
    if (maxLength === void 0)
      maxLength = null;
    if (isRequired === void 0)
      isRequired = false;
    ValueSchema.call(this, name, initialValue);
    this.minLength = minLength;
    this.maxLength = maxLength;
    this.isRequired = isRequired;
  }
  StringSchema.prototype.isValid_11rb$$default = function (value) {
    return this.isValid_11rb$(value, ValueSchema.prototype.isValid_11rb$$default.bind(this)) && (value === null || (this.minLengthIsValid_61zpoe$(value) && this.maxLengthIsValid_61zpoe$(value)));
  };
  StringSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = new ValidationErrors();
    if (this.isRequired && (value == null || equals(value, ''))) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_IS_REQUIRED, void 0, void 0, path));
      return validator;
    }if (value == null) {
      return validator;
    }if (!this.minLengthIsValid_61zpoe$(value) || !this.maxLengthIsValid_61zpoe$(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LENGTH_OUT_OF_BOUNDS_CODE, void 0, void 0, path));
    }return validator;
  };
  StringSchema.prototype.minLengthIsValid_61zpoe$ = function (value) {
    if (this.minLength !== null && value.length < this.minLength.toNumber()) {
      return false;
    }return true;
  };
  StringSchema.prototype.maxLengthIsValid_61zpoe$ = function (value) {
    if (this.maxLength !== null && value.length > this.maxLength.toNumber()) {
      return false;
    }return true;
  };
  StringSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'StringSchema',
    interfaces: [ValueSchema]
  };
  function ValueSchema(name, initialValue) {
    if (name === void 0)
      name = '';
    if (initialValue === void 0)
      initialValue = null;
    this.name = name;
    this.initialValue = initialValue;
  }
  ValueSchema.prototype.isValid_11rb$$default = function (value) {
    return true;
  };
  ValueSchema.prototype.isValid_11rb$ = function (value, callback$default) {
    if (value === void 0)
      value = null;
    return callback$default ? callback$default(value) : this.isValid_11rb$$default(value);
  };
  ValueSchema.prototype.validate_l9l8mx$$default = function (value, path) {
    var validator = new ValidationErrors();
    if (!this.isValid_11rb$(value)) {
      validator.addError_4lqch2$(new ValidationError(ValidationCodes$Companion_getInstance().LF_SOME_ERROR, void 0, void 0, path));
    }return validator;
  };
  ValueSchema.prototype.validate_l9l8mx$ = function (value, path, callback$default) {
    if (value === void 0)
      value = null;
    if (path === void 0)
      path = '/';
    return callback$default ? callback$default(value, path) : this.validate_l9l8mx$$default(value, path);
  };
  ValueSchema.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ValueSchema',
    interfaces: []
  };
  function Serializers() {
    Serializers$Companion_getInstance();
  }
  function Serializers$Companion() {
    Serializers$Companion_instance = this;
    this.jsonNonstrict = Json(void 0, Serializers$Companion$jsonNonstrict$lambda);
  }
  Serializers$Companion.prototype.longSerializer_pdl1vj$ = function (value) {
    var tmp$;
    if (value == null) {
      tmp$ = null;
    } else {
      tmp$ = this.jsonNonstrict.decodeFromString_awif5v$(serializer(kotlin_js_internal_LongCompanionObject), value);
    }
    return tmp$;
  };
  Serializers$Companion.prototype.stringSerializer_pdl1vj$ = function (value) {
    var tmp$;
    if (value != null && !equals(value, '')) {
      tmp$ = this.jsonNonstrict.decodeFromString_awif5v$(serializer_0(kotlin_js_internal_StringCompanionObject), value);
    } else {
      tmp$ = value;
    }
    return tmp$;
  };
  Serializers$Companion.prototype.listSerializer_ybnppd$ = function (value, serializer) {
    var tmp$;
    if (value == null) {
      tmp$ = null;
    } else {
      tmp$ = this.jsonNonstrict.decodeFromString_awif5v$(ListSerializer(serializer), value);
    }
    return tmp$;
  };
  Serializers$Companion.prototype.recordSerializer_ybnppd$ = function (value, serializer) {
    var tmp$;
    if (value == null) {
      tmp$ = null;
    } else {
      tmp$ = this.jsonNonstrict.decodeFromString_awif5v$(serializer, value);
    }
    return tmp$;
  };
  function Serializers$Companion$jsonNonstrict$lambda($receiver) {
    $receiver.isLenient = true;
    $receiver.ignoreUnknownKeys = true;
    return Unit;
  }
  Serializers$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var Serializers$Companion_instance = null;
  function Serializers$Companion_getInstance() {
    if (Serializers$Companion_instance === null) {
      new Serializers$Companion();
    }return Serializers$Companion_instance;
  }
  Serializers.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Serializers',
    interfaces: []
  };
  function BaseRecord() {
  }
  BaseRecord.prototype.get_61zpoe$ = function (propertyName) {
    return null;
  };
  BaseRecord.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'BaseRecord',
    interfaces: []
  };
  function Catalog(name, options) {
    this.name = name;
    this.options = options;
  }
  Catalog.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Catalog',
    interfaces: []
  };
  Catalog.prototype.component1 = function () {
    return this.name;
  };
  Catalog.prototype.component2 = function () {
    return this.options;
  };
  Catalog.prototype.copy_qfi90i$ = function (name, options) {
    return new Catalog(name === void 0 ? this.name : name, options === void 0 ? this.options : options);
  };
  Catalog.prototype.toString = function () {
    return 'Catalog(name=' + Kotlin.toString(this.name) + (', options=' + Kotlin.toString(this.options)) + ')';
  };
  Catalog.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.name) | 0;
    result = result * 31 + Kotlin.hashCode(this.options) | 0;
    return result;
  };
  Catalog.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.name, other.name) && Kotlin.equals(this.options, other.options)))));
  };
  function CatalogOption(value, text, code) {
    if (value === void 0)
      value = null;
    if (text === void 0)
      text = '';
    if (code === void 0)
      code = null;
    this.value = value;
    this.text = text;
    this.code = code;
  }
  CatalogOption.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'CatalogOption',
    interfaces: []
  };
  CatalogOption.prototype.component1 = function () {
    return this.value;
  };
  CatalogOption.prototype.component2 = function () {
    return this.text;
  };
  CatalogOption.prototype.component3 = function () {
    return this.code;
  };
  CatalogOption.prototype.copy_744wau$ = function (value, text, code) {
    return new CatalogOption(value === void 0 ? this.value : value, text === void 0 ? this.text : text, code === void 0 ? this.code : code);
  };
  CatalogOption.prototype.toString = function () {
    return 'CatalogOption(value=' + Kotlin.toString(this.value) + (', text=' + Kotlin.toString(this.text)) + (', code=' + Kotlin.toString(this.code)) + ')';
  };
  CatalogOption.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.value) | 0;
    result = result * 31 + Kotlin.hashCode(this.text) | 0;
    result = result * 31 + Kotlin.hashCode(this.code) | 0;
    return result;
  };
  CatalogOption.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.value, other.value) && Kotlin.equals(this.text, other.text) && Kotlin.equals(this.code, other.code)))));
  };
  function Catalogs(catalogs) {
    this.catalogs = catalogs;
  }
  Catalogs.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Catalogs',
    interfaces: []
  };
  Catalogs.prototype.component1 = function () {
    return this.catalogs;
  };
  Catalogs.prototype.copy_g9g1ex$ = function (catalogs) {
    return new Catalogs(catalogs === void 0 ? this.catalogs : catalogs);
  };
  Catalogs.prototype.toString = function () {
    return 'Catalogs(catalogs=' + Kotlin.toString(this.catalogs) + ')';
  };
  Catalogs.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.catalogs) | 0;
    return result;
  };
  Catalogs.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.catalogs, other.catalogs))));
  };
  function Pair() {
    this.first = null;
    this.second = null;
  }
  Pair.prototype.toList = function () {
    return mutableListOf([this.first, this.second]);
  };
  Pair.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'Pair',
    interfaces: []
  };
  function Pair_init($this) {
    $this = $this || Object.create(Pair.prototype);
    Pair.call($this);
    return $this;
  }
  function Pair_init_0(first, second, $this) {
    $this = $this || Object.create(Pair.prototype);
    Pair.call($this);
    $this.first = first;
    $this.second = second;
    return $this;
  }
  function ValidationCodes() {
    ValidationCodes$Companion_getInstance();
  }
  function ValidationCodes$Companion() {
    ValidationCodes$Companion_instance = this;
    this.LF_SOME_ERROR = 'LF_SOME_ERROR';
    this.LF_IS_REQUIRED = 'LF_IS_REQUIRED';
    this.LF_DATE_OUT_OF_BOUNDS = 'LF_DATE_OUT_OF_BOUNDS';
    this.LF_DATE_UNSUPPORTED_FORMAT = 'LF_DATE_UNSUPPORTED_FORMAT';
    this.LF_SIZE_OUT_OF_BOUNDS = 'LF_SIZE_OUT_OF_BOUNDS';
    this.LF_NUMBER_OUT_OF_BOUNDS = 'LF_NUMBER_OUT_OF_BOUNDS';
    this.LENGTH_OUT_OF_BOUNDS_CODE = 'LENGTH_OUT_OF_BOUNDS_CODE';
    this.UNALLOWED_VALUE_CODE = 'UNALLOWED_VALUE_CODE';
  }
  ValidationCodes$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var ValidationCodes$Companion_instance = null;
  function ValidationCodes$Companion_getInstance() {
    if (ValidationCodes$Companion_instance === null) {
      new ValidationCodes$Companion();
    }return ValidationCodes$Companion_instance;
  }
  ValidationCodes.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ValidationCodes',
    interfaces: []
  };
  function ValidationError(code, isWarning, data, path) {
    ValidationError$Companion_getInstance();
    if (code === void 0)
      code = null;
    if (isWarning === void 0)
      isWarning = false;
    if (data === void 0)
      data = null;
    if (path === void 0)
      path = '/';
    this.code = code;
    this.isWarning = isWarning;
    this.data = data;
    this.path = path;
  }
  function ValidationError$Companion() {
    ValidationError$Companion_instance = this;
  }
  ValidationError$Companion.prototype.serializer = function () {
    return ValidationError$$serializer_getInstance();
  };
  ValidationError$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var ValidationError$Companion_instance = null;
  function ValidationError$Companion_getInstance() {
    if (ValidationError$Companion_instance === null) {
      new ValidationError$Companion();
    }return ValidationError$Companion_instance;
  }
  function ValidationError$$serializer() {
    this.descriptor_icsx0r$_0 = new PluginGeneratedSerialDescriptor('pt.lightweightform.kotlin.type.validator.ValidationError', this, 4);
    this.descriptor.addElement_ivxn3r$('code', true);
    this.descriptor.addElement_ivxn3r$('isWarning', true);
    this.descriptor.addElement_ivxn3r$('data', true);
    this.descriptor.addElement_ivxn3r$('path', true);
    ValidationError$$serializer_instance = this;
  }
  Object.defineProperty(ValidationError$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_icsx0r$_0;
    }
  });
  ValidationError$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    if (!equals(value.code, null) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 0))
      output.encodeNullableSerializableElement_qw92s8$(this.descriptor, 0, internal.StringSerializer, value.code);
    if (!equals(value.isWarning, false) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 1))
      output.encodeBooleanElement_qh7jdn$(this.descriptor, 1, value.isWarning);
    if (!equals(value.data, null) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 2))
      output.encodeNullableSerializableElement_qw92s8$(this.descriptor, 2, new LinkedHashMapSerializer(internal.StringSerializer, internal.StringSerializer), value.data);
    if (!equals(value.path, '/') || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 3))
      output.encodeStringElement_iij8qq$(this.descriptor, 3, value.path);
    output.endStructure_24f42q$(this.descriptor);
  };
  ValidationError$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0
    , local1
    , local2
    , local3;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeNullableSerializableElement_8viuyw$(this.descriptor, 0, internal.StringSerializer, local0);
          bitMask0 |= 1;
          break;
        case 1:
          local1 = input.decodeBooleanElement_szpzho$(this.descriptor, 1);
          bitMask0 |= 2;
          break;
        case 2:
          local2 = input.decodeNullableSerializableElement_8viuyw$(this.descriptor, 2, new LinkedHashMapSerializer(internal.StringSerializer, internal.StringSerializer), local2);
          bitMask0 |= 4;
          break;
        case 3:
          local3 = input.decodeStringElement_szpzho$(this.descriptor, 3);
          bitMask0 |= 8;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return ValidationError_init(bitMask0, local0, local1, local2, local3, null);
  };
  ValidationError$$serializer.prototype.childSerializers = function () {
    return [new NullableSerializer(internal.StringSerializer), internal.BooleanSerializer, new NullableSerializer(new LinkedHashMapSerializer(internal.StringSerializer, internal.StringSerializer)), internal.StringSerializer];
  };
  ValidationError$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var ValidationError$$serializer_instance = null;
  function ValidationError$$serializer_getInstance() {
    if (ValidationError$$serializer_instance === null) {
      new ValidationError$$serializer();
    }return ValidationError$$serializer_instance;
  }
  function ValidationError_init(seen1, code, isWarning, data, path, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(ValidationError.prototype);
    if ((seen1 & 1) === 0)
      $this.code = null;
    else
      $this.code = code;
    if ((seen1 & 2) === 0)
      $this.isWarning = false;
    else
      $this.isWarning = isWarning;
    if ((seen1 & 4) === 0)
      $this.data = null;
    else
      $this.data = data;
    if ((seen1 & 8) === 0)
      $this.path = '/';
    else
      $this.path = path;
    return $this;
  }
  ValidationError.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ValidationError',
    interfaces: []
  };
  ValidationError.prototype.component1 = function () {
    return this.code;
  };
  ValidationError.prototype.component2 = function () {
    return this.isWarning;
  };
  ValidationError.prototype.component3 = function () {
    return this.data;
  };
  ValidationError.prototype.component4 = function () {
    return this.path;
  };
  ValidationError.prototype.copy_gag5is$ = function (code, isWarning, data, path) {
    return new ValidationError(code === void 0 ? this.code : code, isWarning === void 0 ? this.isWarning : isWarning, data === void 0 ? this.data : data, path === void 0 ? this.path : path);
  };
  ValidationError.prototype.toString = function () {
    return 'ValidationError(code=' + Kotlin.toString(this.code) + (', isWarning=' + Kotlin.toString(this.isWarning)) + (', data=' + Kotlin.toString(this.data)) + (', path=' + Kotlin.toString(this.path)) + ')';
  };
  ValidationError.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.code) | 0;
    result = result * 31 + Kotlin.hashCode(this.isWarning) | 0;
    result = result * 31 + Kotlin.hashCode(this.data) | 0;
    result = result * 31 + Kotlin.hashCode(this.path) | 0;
    return result;
  };
  ValidationError.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && (Kotlin.equals(this.code, other.code) && Kotlin.equals(this.isWarning, other.isWarning) && Kotlin.equals(this.data, other.data) && Kotlin.equals(this.path, other.path)))));
  };
  function ValidationErrors(errors) {
    ValidationErrors$Companion_getInstance();
    if (errors === void 0) {
      errors = ArrayList_init();
    }this.errors = errors;
  }
  ValidationErrors.prototype.addError_4lqch2$ = function (validationError) {
    this.errors.add_11rb$(validationError);
  };
  ValidationErrors.prototype.addErrors_ngmtp$ = function (validationErrors) {
    this.errors.addAll_brywnq$(validationErrors.errors);
  };
  function ValidationErrors$Companion() {
    ValidationErrors$Companion_instance = this;
  }
  ValidationErrors$Companion.prototype.serializer = function () {
    return ValidationErrors$$serializer_getInstance();
  };
  ValidationErrors$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var ValidationErrors$Companion_instance = null;
  function ValidationErrors$Companion_getInstance() {
    if (ValidationErrors$Companion_instance === null) {
      new ValidationErrors$Companion();
    }return ValidationErrors$Companion_instance;
  }
  function ValidationErrors$$serializer() {
    this.descriptor_5na70y$_0 = new PluginGeneratedSerialDescriptor('pt.lightweightform.kotlin.type.validator.ValidationErrors', this, 1);
    this.descriptor.addElement_ivxn3r$('errors', true);
    ValidationErrors$$serializer_instance = this;
  }
  Object.defineProperty(ValidationErrors$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_5na70y$_0;
    }
  });
  ValidationErrors$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    if (!equals(value.errors, ArrayList_init()) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 0))
      output.encodeSerializableElement_r4qlx7$(this.descriptor, 0, new ArrayListSerializer(ValidationError$$serializer_getInstance()), value.errors);
    output.endStructure_24f42q$(this.descriptor);
  };
  ValidationErrors$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeSerializableElement_12e8id$(this.descriptor, 0, new ArrayListSerializer(ValidationError$$serializer_getInstance()), local0);
          bitMask0 |= 1;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return ValidationErrors_init(bitMask0, local0, null);
  };
  ValidationErrors$$serializer.prototype.childSerializers = function () {
    return [new ArrayListSerializer(ValidationError$$serializer_getInstance())];
  };
  ValidationErrors$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var ValidationErrors$$serializer_instance = null;
  function ValidationErrors$$serializer_getInstance() {
    if (ValidationErrors$$serializer_instance === null) {
      new ValidationErrors$$serializer();
    }return ValidationErrors$$serializer_instance;
  }
  function ValidationErrors_init(seen1, errors, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(ValidationErrors.prototype);
    if ((seen1 & 1) === 0) {
      $this.errors = ArrayList_init();
    } else
      $this.errors = errors;
    return $this;
  }
  ValidationErrors.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ValidationErrors',
    interfaces: []
  };
  ValidationErrors.prototype.component1 = function () {
    return this.errors;
  };
  ValidationErrors.prototype.copy_gsvxne$ = function (errors) {
    return new ValidationErrors(errors === void 0 ? this.errors : errors);
  };
  ValidationErrors.prototype.toString = function () {
    return 'ValidationErrors(errors=' + Kotlin.toString(this.errors) + ')';
  };
  ValidationErrors.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.errors) | 0;
    return result;
  };
  ValidationErrors.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.errors, other.errors))));
  };
  function ValidationErrorsMap(errors) {
    ValidationErrorsMap$Companion_getInstance();
    if (errors === void 0) {
      errors = LinkedHashMap_init();
    }this.errors = errors;
  }
  ValidationErrorsMap.prototype.addError_h5iy88$ = function (validationError, path) {
    if (this.errors.get_11rb$(path) != null) {
      ensureNotNull(this.errors.get_11rb$(path)).add_11rb$(validationError);
    } else {
      var $receiver = this.errors;
      var value = mutableListOf([validationError]);
      $receiver.put_xwzc9p$(path, value);
    }
  };
  ValidationErrorsMap.prototype.addErrors_y8bess$ = function (validationErrors, path) {
    if (this.errors.get_11rb$(path) != null) {
      ensureNotNull(this.errors.get_11rb$(path)).addAll_brywnq$(validationErrors);
    } else {
      this.errors.put_xwzc9p$(path, validationErrors);
    }
  };
  ValidationErrorsMap.prototype.putAll_o2ev7z$ = function (otherValidator) {
    this.errors.putAll_a2k3zr$(otherValidator.errors);
  };
  ValidationErrorsMap.prototype.hasErrors_ivxn3r$ = function (path, strict) {
    if (path === void 0)
      path = '/';
    if (strict === void 0)
      strict = false;
    var hasErrors = {v: false};
    var tmp$;
    tmp$ = this.errors.entries.iterator();
    while (tmp$.hasNext()) {
      var element = tmp$.next();
      var key = element.key;
      var entry = element.value;
      if (strict && equals(key, path) && entry.size > 0 || (!strict && indexOf(key, path) > -1 && entry.size > 0)) {
        hasErrors.v = true;
      }}
    return hasErrors.v;
  };
  ValidationErrorsMap.prototype.getErrors_61zpoe$ = function (path) {
    var tmp$;
    return (tmp$ = this.errors.get_11rb$(path)) != null ? tmp$ : ArrayList_init();
  };
  function ValidationErrorsMap$Companion() {
    ValidationErrorsMap$Companion_instance = this;
  }
  ValidationErrorsMap$Companion.prototype.serializer = function () {
    return ValidationErrorsMap$$serializer_getInstance();
  };
  ValidationErrorsMap$Companion.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: 'Companion',
    interfaces: []
  };
  var ValidationErrorsMap$Companion_instance = null;
  function ValidationErrorsMap$Companion_getInstance() {
    if (ValidationErrorsMap$Companion_instance === null) {
      new ValidationErrorsMap$Companion();
    }return ValidationErrorsMap$Companion_instance;
  }
  function ValidationErrorsMap$$serializer() {
    this.descriptor_cthkpg$_0 = new PluginGeneratedSerialDescriptor('pt.lightweightform.kotlin.type.validator.ValidationErrorsMap', this, 1);
    this.descriptor.addElement_ivxn3r$('errors', true);
    ValidationErrorsMap$$serializer_instance = this;
  }
  Object.defineProperty(ValidationErrorsMap$$serializer.prototype, 'descriptor', {
    configurable: true,
    get: function () {
      return this.descriptor_cthkpg$_0;
    }
  });
  ValidationErrorsMap$$serializer.prototype.serialize_55azsf$ = function (encoder, value) {
    var output = encoder.beginStructure_24f42q$(this.descriptor);
    if (!equals(value.errors, LinkedHashMap_init()) || output.shouldEncodeElementDefault_szpzho$(this.descriptor, 0))
      output.encodeSerializableElement_r4qlx7$(this.descriptor, 0, new LinkedHashMapSerializer(internal.StringSerializer, new ArrayListSerializer(ValidationError$$serializer_getInstance())), value.errors);
    output.endStructure_24f42q$(this.descriptor);
  };
  ValidationErrorsMap$$serializer.prototype.deserialize_bq71mq$ = function (decoder) {
    var index;
    var bitMask0 = 0;
    var local0;
    var input = decoder.beginStructure_24f42q$(this.descriptor);
    loopLabel: while (true) {
      index = input.decodeElementIndex_24f42q$(this.descriptor);
      switch (index) {
        case 0:
          local0 = input.decodeSerializableElement_12e8id$(this.descriptor, 0, new LinkedHashMapSerializer(internal.StringSerializer, new ArrayListSerializer(ValidationError$$serializer_getInstance())), local0);
          bitMask0 |= 1;
          break;
        case -1:
          break loopLabel;
        default:throw new UnknownFieldException(index);
      }
    }
    input.endStructure_24f42q$(this.descriptor);
    return ValidationErrorsMap_init(bitMask0, local0, null);
  };
  ValidationErrorsMap$$serializer.prototype.childSerializers = function () {
    return [new LinkedHashMapSerializer(internal.StringSerializer, new ArrayListSerializer(ValidationError$$serializer_getInstance()))];
  };
  ValidationErrorsMap$$serializer.$metadata$ = {
    kind: Kind_OBJECT,
    simpleName: '$serializer',
    interfaces: [GeneratedSerializer]
  };
  var ValidationErrorsMap$$serializer_instance = null;
  function ValidationErrorsMap$$serializer_getInstance() {
    if (ValidationErrorsMap$$serializer_instance === null) {
      new ValidationErrorsMap$$serializer();
    }return ValidationErrorsMap$$serializer_instance;
  }
  function ValidationErrorsMap_init(seen1, errors, serializationConstructorMarker) {
    var $this = serializationConstructorMarker || Object.create(ValidationErrorsMap.prototype);
    if ((seen1 & 1) === 0) {
      $this.errors = LinkedHashMap_init();
    } else
      $this.errors = errors;
    return $this;
  }
  ValidationErrorsMap.$metadata$ = {
    kind: Kind_CLASS,
    simpleName: 'ValidationErrorsMap',
    interfaces: []
  };
  ValidationErrorsMap.prototype.component1 = function () {
    return this.errors;
  };
  ValidationErrorsMap.prototype.copy_d7epi$ = function (errors) {
    return new ValidationErrorsMap(errors === void 0 ? this.errors : errors);
  };
  ValidationErrorsMap.prototype.toString = function () {
    return 'ValidationErrorsMap(errors=' + Kotlin.toString(this.errors) + ')';
  };
  ValidationErrorsMap.prototype.hashCode = function () {
    var result = 0;
    result = result * 31 + Kotlin.hashCode(this.errors) | 0;
    return result;
  };
  ValidationErrorsMap.prototype.equals = function (other) {
    return this === other || (other !== null && (typeof other === 'object' && (Object.getPrototypeOf(this) === Object.getPrototypeOf(other) && Kotlin.equals(this.errors, other.errors))));
  };
  function appendToPath(path, name) {
    return endsWith(path, '/') ? path + name : path + '/' + name;
  }
  _.DummyType = DummyType;
  var package$pt = _.pt || (_.pt = {});
  var package$lightweightform = package$pt.lightweightform || (package$pt.lightweightform = {});
  var package$kotlin = package$lightweightform.kotlin || (package$lightweightform.kotlin = {});
  var package$js = package$kotlin.js || (package$kotlin.js = {});
  var package$extensions = package$js.extensions || (package$js.extensions = {});
  package$extensions.isNullOrZero_mvg40e$ = isNullOrZero;
  package$extensions.isNullOrZero_2nurcp$ = isNullOrZero_0;
  package$extensions.isNullOrZero_ck760i$ = isNullOrZero_1;
  var package$schema = package$kotlin.schema || (package$kotlin.schema = {});
  package$schema.BooleanSchema = BooleanSchema;
  Object.defineProperty(DateStringSchema, 'Companion', {
    get: DateStringSchema$Companion_getInstance
  });
  package$schema.DateStringSchema = DateStringSchema;
  package$schema.ListSchema = ListSchema;
  package$schema.MapSchema = MapSchema;
  package$schema.MaybeSchema = MaybeSchema;
  package$schema.NumberSchema = NumberSchema;
  package$schema.PairSchema = PairSchema;
  package$schema.RecordSchema = RecordSchema;
  package$schema.StringSchema = StringSchema;
  package$schema.ValueSchema = ValueSchema;
  Object.defineProperty(Serializers, 'Companion', {
    get: Serializers$Companion_getInstance
  });
  var package$serializer = package$kotlin.serializer || (package$kotlin.serializer = {});
  package$serializer.Serializers = Serializers;
  var package$storage = package$kotlin.storage || (package$kotlin.storage = {});
  package$storage.BaseRecord = BaseRecord;
  var package$type = package$kotlin.type || (package$kotlin.type = {});
  var package$catalog = package$type.catalog || (package$type.catalog = {});
  package$catalog.Catalog = Catalog;
  package$catalog.CatalogOption = CatalogOption;
  package$catalog.Catalogs = Catalogs;
  package$type.Pair_init_q3lmfv$ = Pair_init;
  package$type.Pair_init_o5fpdy$ = Pair_init_0;
  package$type.Pair = Pair;
  Object.defineProperty(ValidationCodes, 'Companion', {
    get: ValidationCodes$Companion_getInstance
  });
  var package$validator = package$type.validator || (package$type.validator = {});
  package$validator.ValidationCodes = ValidationCodes;
  Object.defineProperty(ValidationError, 'Companion', {
    get: ValidationError$Companion_getInstance
  });
  Object.defineProperty(ValidationError, '$serializer', {
    get: ValidationError$$serializer_getInstance
  });
  package$validator.ValidationError_init_mif54a$ = ValidationError_init;
  package$validator.ValidationError = ValidationError;
  Object.defineProperty(ValidationErrors, 'Companion', {
    get: ValidationErrors$Companion_getInstance
  });
  Object.defineProperty(ValidationErrors, '$serializer', {
    get: ValidationErrors$$serializer_getInstance
  });
  package$validator.ValidationErrors_init_lb90sw$ = ValidationErrors_init;
  package$validator.ValidationErrors = ValidationErrors;
  Object.defineProperty(ValidationErrorsMap, 'Companion', {
    get: ValidationErrorsMap$Companion_getInstance
  });
  Object.defineProperty(ValidationErrorsMap, '$serializer', {
    get: ValidationErrorsMap$$serializer_getInstance
  });
  package$validator.ValidationErrorsMap_init_nlrul4$ = ValidationErrorsMap_init;
  package$validator.ValidationErrorsMap = ValidationErrorsMap;
  var package$util = package$kotlin.util || (package$kotlin.util = {});
  package$util.appendToPath_puj7f4$ = appendToPath;
  ValidationError$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  ValidationErrors$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  ValidationErrorsMap$$serializer.prototype.typeParametersSerializers = GeneratedSerializer.prototype.typeParametersSerializers;
  Kotlin.defineModule('lf-kotlin-common-js', _);
  return _;
}(module.exports, require('kotlin'), require('klock-root-klock-jsLegacy'), require('kotlinx-serialization-kotlinx-serialization-core-jsLegacy'), require('kotlinx-serialization-kotlinx-serialization-json-jsLegacy')));

//# sourceMappingURL=lf-kotlin-common-js.js.map
